import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

export default function Footer() {
  const [footerInfo, setFooterInfo] = useState({
    kontakt_adresse: 'Holtvej 8, 6470 Sydals · Håndlavet på Sydals',
    kontakt_find_smiley_url: 'https://www.findsmiley.dk/app/758730'
  });

  useEffect(() => {
    async function fetchFooterInfo() {
      try {
        const res = await fetch('/_api/public/v2/content/forside');
        if (res.ok) {
          const json = await res.json();
          if (json?.items?.[0]) {
            const item = json.items[0];
            setFooterInfo({
              kontakt_adresse: item.kontakt_adresse ? `${item.kontakt_adresse} · Håndlavet på Sydals` : 'Holtvej 8, 6470 Sydals · Håndlavet på Sydals',
              kontakt_find_smiley_url: item.kontakt_find_smiley_url || 'https://www.findsmiley.dk/app/758730'
            });
          }
        }
      } catch (err) {
        console.warn('Using fallback footer info:', err);
      }
    }
    fetchFooterInfo();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer
      className="relative w-full bg-[#F2EEE7] text-[#37332F] py-12 px-6 md:px-12 border-t border-[#DED7CC] overflow-hidden"
      aria-label="Sidefod"
    >
      <div className="relative mx-auto max-w-7xl flex flex-col sm:flex-row items-center justify-between gap-6">
        {/* Brand identity */}
        <div className="flex flex-col sm:flex-row items-center gap-4 text-center sm:text-left">
          <span className="font-['Cormorant_Garamond'] text-xl tracking-[0.2em] uppercase font-light text-[#37332F]">
            Destilleriet Als
          </span>
          <span className="hidden sm:inline-block text-[#DED7CC]">|</span>
          <span className="text-xs font-['Montserrat'] text-[#5E5852] font-light">
            {footerInfo.kontakt_adresse}
          </span>
        </div>

        {/* Minimal Scandinavian "Gå til toppen" button */}
        <button
          onClick={scrollToTop}
          className="inline-flex items-center gap-3 px-5 py-2.5 border border-[#37332F]/30 hover:border-[#37332F] hover:bg-[#37332F] hover:text-[#F6F2EB] text-[#37332F] font-['Montserrat'] text-[11px] uppercase tracking-[0.22em] font-normal transition-all duration-300 cursor-pointer focus:outline-none"
          aria-label="Gå til toppen af siden"
        >
          <span>Gå til toppen</span>
          <ArrowUp className="w-3 h-3" aria-hidden="true" />
        </button>
      </div>

      <div className="mt-8 pt-6 border-t border-[#DED7CC]/70 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left text-[11px] font-['Montserrat'] text-[#8E867E]">
        <span>© {new Date().getFullYear()} KALAS Distillery · Alle rettigheder forbeholdes.</span>
        <a
          href={footerInfo.kontakt_find_smiley_url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 text-[#5E5852] hover:text-[#37332F] transition-colors underline underline-offset-4 decoration-[#DED7CC] hover:decoration-[#37332F]"
        >
          <span>Fødevarestyrelsens kontrolrapport (Find Smiley)</span>
          <span className="text-[10px] text-[#C99850]">↗</span>
        </a>
      </div>
    </footer>
  );
}
